module.exports = __webpack_public_path__ + "static/media/times-red.5a68a7a3.svg";